'use client';

import { type FC, useMemo, useState, useEffect } from 'react';
import { resetSignUp } from 'app/features/landing/signup/signupSlice';
import { useAppDispatch } from 'app/store';
import { SignUpStepWithAnalytics } from './SignUpStep/SignUpStep';
import { EmailStepWithAnalytics } from './EmailStep/EmailStep';
import { MobileNumberStepWithAnalytics } from './MobileNumberStep/MobileNumberStep';
import { SuccessStepWithAnalytics } from './SuccessStep/SuccessStep';
import { SignupFormProvider, type FormsSteps, type SignupPageContextValue } from './SignupFormContext';

const steps: Record<FormsSteps, FC> = {
  signup: SignUpStepWithAnalytics,
  email: EmailStepWithAnalytics,
  mobileNumber: MobileNumberStepWithAnalytics,
  success: SuccessStepWithAnalytics,
};

export function SignupForm() {
  const [activeStep, setActiveStep] = useState<FormsSteps>('signup');
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetSignUp());
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only want to trigger onMount
  }, []);

  const contextValue: SignupPageContextValue = useMemo(
    () => ({ activeStep, setActiveStep }),
    [activeStep, setActiveStep]
  );

  const CurrentStep = steps[activeStep];

  return (
    <SignupFormProvider value={contextValue}>
      <CurrentStep />
    </SignupFormProvider>
  );
}
